import { h } from "vue";

import NotificationsErrorLogId from "../ui/NotificationsErrorLogId.vue";

export const formatErrorNotification = (error) => {
    return {
        type: "error",
        title: error.data?.message ?? error.systemMessage ?? "Ошибка",
        text: error.data?.logId
            ? h("p", null, [
                  "Скопируйте log id: ",
                  h(NotificationsErrorLogId, { logId: error.data.logId }),
                  " и отправьте его нам! Так вы поможете нам понять какая ошибка у вас произошла!",
              ])
            : null,
    };
};
